<template>

  <div class="card">
    <div class="card-header">
        Indeed
    </div>
    <div class="card-body">
        <img
        src="https://s3-sa-east-1.amazonaws.com/quickin-common-files/posting-jobs-logos/indeed.jpg"
        class="mb-2"
        style="max-width: 200px">
        <p>{{ $t('Indeed.com is a job search engine created in the United States in 2004.') }}</p>
        <button
        type="button"
        class="btn btn-secondary disabled">{{ $t('Automatic') }}</button>
    </div>
    </div>

</template>

<script>
export default {
  name: 'JobAdvertiseBoardIndeed',
  props: [
    'jobBoard'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoardsIndeed.vue